<script setup lang="ts">
type Props = {
  open: boolean
}
type Emits = {
  toggle: []
}

defineProps<Props>()
const emit = defineEmits<Emits>()
</script>

<template>
  <button
    class="tw-transition-duration-300 tw-relative tw-h-6 tw-w-5 tw-cursor-pointer"
    type="button"
    @click.stop="emit('toggle')"
  >
    <span
      class="tw-absolute tw-top-[calc(50%-6px)] tw-block tw-h-3xs tw-w-5 tw-bg-fill tw-transition-all tw-duration-150"
      :class="{
        '!tw-top-[calc(50%-2px)] tw-rotate-45 tw-bg-fill-primary': open,
      }"
    />
    <span
      class="tw-absolute tw-bottom-[calc(50%-6px)] tw-block tw-h-3xs tw-w-5 tw-bg-fill tw-transition-all tw-duration-150"
      :class="{
        'tw-bottom-[unset] tw-top-[calc(50%-2px)] -tw-rotate-45 tw-bg-fill-primary':
          open,
      }"
    />
  </button>
</template>
